import RangeSliderField from './RangeSliderField.component';

export default RangeSliderField;